/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for user registration that includes password fields.
 * @export
 * @interface UserSignup
 */
export interface UserSignup {
    /**
     * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
     * @type {string}
     * @memberof UserSignup
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignup
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignup
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignup
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignup
     */
    password1: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignup
     */
    password2: string;
}

/**
 * Check if a given object implements the UserSignup interface.
 */
export function instanceOfUserSignup(value: object): value is UserSignup {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('password1' in value) || value['password1'] === undefined) return false;
    if (!('password2' in value) || value['password2'] === undefined) return false;
    return true;
}

export function UserSignupFromJSON(json: any): UserSignup {
    return UserSignupFromJSONTyped(json, false);
}

export function UserSignupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSignup {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'password1': json['password1'],
        'password2': json['password2'],
    };
}

  export function UserSignupToJSON(json: any): UserSignup {
      return UserSignupToJSONTyped(json, false);
  }

  export function UserSignupToJSONTyped(value?: UserSignup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'password1': value['password1'],
        'password2': value['password2'],
    };
}

